<template>
  <Claimed v-if="unclaimedPro.account_claimed" :pro="unclaimedPro" />
  <Unclaimed v-else :pro="unclaimedPro" />
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Claimed from './Claimed'
import Unclaimed from './Unclaimed'

export default {
  name: 'ProInviteView',

  props: ['pro_token'],

  components: { Claimed, Unclaimed },

  computed: {
    ...mapGetters('auth', ['unclaimedPro'])
  },

  methods: {
    ...mapActions('auth', ['loadUnclaimedPro']),
  },

  created() {
    this.loadUnclaimedPro(this.pro_token)
  },
}
</script>